import React, { useState } from 'react'
import { createPortal } from 'react-dom';
import { RxCross1 } from 'react-icons/rx';
import { useDispatch } from 'react-redux';
import { CreateEventByAdmin, CreateEventByAdminFeatured } from '../../../redux/actions/Admin/AdminActions';
import toast from 'react-hot-toast';
import Spinner from '../../Loading/Spinner';

const MODES = { TRENDING: 1, LATEST: 2, COMMUNITY: 3 };
const MODE_LABELS = { [MODES.TRENDING]: "Trending Event", [MODES.LATEST]: "Latest Event", [MODES.COMMUNITY]: "Community Event" };

const inputClass =
    "w-full px-4 py-3 rounded-xl bg-white/[0.06] border border-white/[0.12] text-white text-[14px] placeholder:text-white/35 focus:outline-none focus:ring-2 focus:ring-[#E52324]/30 focus:border-[#E52324]/40 transition-all";

const labelClass =
    "block text-[11px] text-white/70 uppercase tracking-wider mb-1.5 font-semibold";

const CreateEvent = ({ event, setEvent, setcreateevent }) => {
    const [modal, setModal] = useState(MODES.TRENDING);
    const [Paragraph, setParagraph] = useState("");
    const [image, setImage] = useState(null);
    const [submitting, setSubmitting] = useState(false);

    const dispatch = useDispatch();


    const uploadImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = () => {
                setImage(file);
            };
            reader.readAsDataURL(file);
        }
    };



    const createeventFunction = async () => {
        if (modal === MODES.TRENDING) {
            // Trending = isFeatured: false, POST /event/create (requires image)
            if (!Paragraph || !event || !image) {
                return toast.error("Please Enter All fields");
            }
            setSubmitting(true);
            try {
                const formdata = new FormData();
                formdata.append("event", JSON.stringify(event));
                formdata.append("paragarph", Paragraph);
                formdata.append("file", image);
                formdata.append("isFeatured", false);
                await dispatch(CreateEventByAdmin(formdata, "create"));
                setEvent({});
                setParagraph("");
                setImage(null);
                setcreateevent(false);
            } finally {
                setSubmitting(false);
            }
        } else if (modal === MODES.COMMUNITY) {
            // Community = isCommunity: true, POST /event/create/feature (uses event's own image)
            if (!Paragraph || !event) {
                return toast.error("Please Enter All fields");
            }
            if (!event?.image) {
                return toast.error("Selected event has no image");
            }
            setSubmitting(true);
            try {
                const formdata = new FormData();
                formdata.append("event", JSON.stringify(event));
                formdata.append("paragarph", Paragraph);
                formdata.append("isCommunity", true);
                await dispatch(CreateEventByAdmin(formdata, "create/feature"));
                setEvent({});
                setParagraph("");
                setcreateevent(false);
            } finally {
                setSubmitting(false);
            }
        } else {
            // Latest = isFeatured: true, POST /event/create/feature (no image required — uses event image)
            if (!Paragraph || !event) {
                return toast.error("Please Enter All fields");
            }
            setSubmitting(true);
            try {
                const formdata = new FormData();
                formdata.append("event", JSON.stringify(event));
                formdata.append("paragarph", Paragraph);
                formdata.append("isFeatured", true);
                await dispatch(CreateEventByAdminFeatured(formdata, "create/feature"));
                setEvent({});
                setParagraph("");
                setImage(null);
                setcreateevent(false);
            } finally {
                setSubmitting(false);
            }
        }
    };

    const cycleModal = () => {
        setModal((m) => (m >= 3 ? 1 : m + 1));
    };







    return createPortal(
        <div className="z-[999999] fixed inset-0 flex h-full w-full items-center justify-center bg-black/65 backdrop-blur-sm py-10 px-4">
            <div className="max-h-[90vh] relative w-full max-w-xl overflow-y-auto rounded-2xl bg-[#0B1120] border border-[#1a2744] shadow-2xl shadow-black/50">
                <div className="sticky top-0 z-10 flex items-center justify-between px-5 py-4 border-b border-[#1a2744] bg-[#0B1120]">
                    <h3 className="text-[18px] font-bold text-white tracking-tight">
                        Set as {MODE_LABELS[modal]}
                    </h3>
                    <button
                        type="button"
                        aria-label="Close"
                        className={`p-1.5 rounded-lg text-white/50 hover:text-white hover:bg-white/[0.08] transition-all ${submitting ? "cursor-not-allowed opacity-50" : "cursor-pointer"}`}
                        onClick={() => {
                            if (submitting) return;
                            setcreateevent(false);
                            setEvent({});
                            setParagraph("");
                            setImage(null);
                        }}
                    >
                        <RxCross1 className="text-[22px]" />
                    </button>
                </div>

                <div className="px-5 py-6 space-y-5">
                    <div>
                        <label htmlFor="carousel-paragraph" className={labelClass}>
                            Carousal Paragraph
                        </label>
                        <input
                            id="carousel-paragraph"
                            value={Paragraph}
                            onChange={(e) => setParagraph(e.target.value)}
                            type="text"
                            placeholder="Please Enter Paragraph"
                            className={inputClass}
                        />
                    </div>

                    {(modal === MODES.COMMUNITY || modal === MODES.LATEST) && event?.image && (
                        <p className="text-[13px] text-white/60 pl-0.5">
                            Carousel will use the event&apos;s image
                        </p>
                    )}

                    {modal === MODES.TRENDING && (
                        <div>
                            <label htmlFor="carousel-image" className={labelClass}>
                                Carousal Image
                            </label>
                            <input
                                id="carousel-image"
                                onChange={uploadImageChange}
                                type="file"
                                accept="image/*"
                                className={`${inputClass} file:mr-4 file:py-1 file:px-3 file:rounded-lg file:border-0 file:text-[12px] file:bg-[#E52324]/20 file:text-[#E52324] file:font-semibold`}
                            />
                        </div>
                    )}

                    <button
                        type="button"
                        className="w-full py-3 rounded-xl bg-[#E52324] hover:bg-[#d11f20] text-white text-[15px] font-bold flex items-center justify-center gap-2 transition-colors disabled:opacity-70 disabled:cursor-not-allowed"
                        onClick={createeventFunction}
                        disabled={submitting}
                    >
                        {submitting ? (
                            <>
                                <Spinner />
                                <span>Creating...</span>
                            </>
                        ) : (
                            "Create"
                        )}
                    </button>

                    <p
                        className={`text-center text-[13px] text-white/55 hover:text-[#E52324] transition-colors ${submitting ? "cursor-not-allowed opacity-50" : "cursor-pointer underline underline-offset-2 decoration-white/25 hover:decoration-[#E52324]/50"}`}
                        onClick={() => !submitting && cycleModal()}
                    >
                        Set as {modal === MODES.TRENDING ? "Latest Event" : modal === MODES.LATEST ? "Community Event" : "Trending Event"} instead
                    </p>
                </div>
            </div>
        </div>,
        document.body
    )
}

export default CreateEvent
